import styled from 'styled-components';

import { scale100, scale110, scale130, scale210 } from '@xingternal/tokens';

import {
  Hero as XingternalHero,
  BodyCopy as XingternalBodyCopy,
} from '@xingternal/typography';

import { mediaConfined, mediaSmallOrTiny } from '@xingternal/layout-tokens';
import { sectionInnerContainerMixin, sectionMixin } from '../variables.style';

export const Hero = styled(XingternalHero)`
  @media ${mediaSmallOrTiny} {
    margin-bottom: ${scale130};
  }
`;
export const BodyCopy = styled(XingternalBodyCopy)`
  margin-bottom: ${scale110};
`;

export const Container = styled.div`
  @media ${mediaConfined} {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  ${sectionMixin}
  ${sectionInnerContainerMixin}

  & > * {
    @media ${mediaConfined} {
      flex: 0 1 50%;
    }
  }
`;

export const ImageDesktopContainer = styled.div`
  order: ${({ imageOnTheRight }) => !imageOnTheRight && -1};
  ${({ imageOnTheRight }) =>
    `margin-${imageOnTheRight ? 'left' : 'right'}: ${scale210}`};

  @media ${mediaSmallOrTiny} {
    display: none;
  }
`;

export const Img = styled.img`
  max-width: 100%;
`;

export const ImgMobileContainer = styled.div`
  margin-bottom: ${scale130};
  margin-left: ${scale100};
  margin-right: ${scale100};
  width: calc(100% - (${scale100} + ${scale100}));

  @media ${mediaConfined} {
    display: none;
  }
`;
